var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { screen, within } from '@testing-library/react';
import { t } from 'i18next';
var generateTestUtils = function (translations) { return ({
    popoverFilter: {
        find: function () { return screen.findByRole('presentation'); },
        get: function () { return screen.getByRole('presentation'); },
    },
    popoverFilterButton: {
        find: function (label) {
            if (label === void 0) { label = translations.label; }
            return screen.findByRole('button', { name: new RegExp(label) });
        },
        get: function (label) {
            if (label === void 0) { label = translations.label; }
            return screen.getByRole('button', { name: new RegExp(label) });
        },
    },
    clearFilterButton: {
        find: function () { return screen.findByRole('button', { name: translations.clear }); },
        get: function () { return screen.getByRole('button', { name: translations.clear }); },
    },
    deleteFilterButton: {
        find: function () { return screen.findByRole('button', { name: translations.delete }); },
        get: function () { return screen.getByRole('button', { name: translations.delete }); },
        query: function () { return screen.queryByRole('button', { name: translations.delete }); },
    },
    editFilterButton: {
        find: function () { return screen.findByRole('button', { name: translations.edit }); },
        get: function () { return screen.getByRole('button', { name: translations.edit }); },
        query: function () { return screen.queryByRole('button', { name: translations.edit }); },
    },
    saveFilterButton: {
        find: function () { return screen.findByRole('button', { name: translations.save }); },
        get: function () { return screen.getByRole('button', { name: translations.save }); },
        query: function () { return screen.queryByRole('button', { name: translations.save }); },
    },
    autocomplete: {
        get: function () { return screen.getByPlaceholderText(translations.label); },
    },
    autocompleteList: {
        find: function () { return __awaiter(void 0, void 0, void 0, function () {
            var presentations;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, screen.findAllByRole('presentation')];
                    case 1:
                        presentations = _a.sent();
                        expect(presentations).toHaveLength(2);
                        return [2 /*return*/, presentations[1]];
                }
            });
        }); },
    },
    autocompleteOption: {
        getByLabel: function (listElement, optionLabel) { return within(listElement).getByRole('option', { name: optionLabel }); },
    },
    invalidQuery: {
        get: function () { return screen.getByLabelText(t('components.query.invalid_query.label')); },
        query: function () { return screen.queryByLabelText(t('components.query.invalid_query.label')); },
    },
}); };
export var nodeFilterComponentsTestUtils = generateTestUtils(t('components.nodes.filter.button'));
export var portFilterComponentsTestUtils = generateTestUtils(t('components.ports.filter.button'));
export var resourceFilterComponentsTestUtils = generateTestUtils(t('components.resources.filter.button'));
